import React from "react";
import styles from "./Chip.module.scss";
import { combineClasses } from "@/lib/utils";

export type ChipVariant = "neutral" | "success" | "warning" | "danger" | "info";

interface ChipProps {
  children: React.ReactNode;
  variant?: ChipVariant;
  className?: string;
}

const VARIANT_CLASS: Record<ChipVariant, string> = {
  neutral: "neutral",
  success: "success",
  warning: "warning",
  danger: "danger",
  info: "info",
};

const Chip: React.FC<ChipProps> = ({ children, variant = "neutral", className = "" }) => (
  <span className={combineClasses(styles.chip, styles[VARIANT_CLASS[variant]], className)}>
    {children}
  </span>
);

export default Chip;
